import { currentPlatform, formatShortcut } from "./formatShortcut";
import { ShortcutView, type ShortcutSize } from "./ShortcutView";

export interface ShortcutProps {
    /** Hotkey string: `+` joins a chord (`mod+k`), `>` a sequence (`g>t`). */
    keys: string;
    size?: ShortcutSize;
    className?: string;
}

/** Key chips for a hotkey string, labelled for the user's platform. */
export const Shortcut = ({ keys, size, className }: ShortcutProps) => (
    <ShortcutView
        steps={formatShortcut(keys, currentPlatform)}
        size={size}
        className={className}
    />
);
